/* eslint-disable @typescript-eslint/no-require-imports */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { getDarkMode } from "../../theme";
import { isPad, smallPad, isJ18, isJ18Full } from "../../assets";
import styles from "./index.module.scss";

interface ImageConfig {
  url: string;
  version?: string;
}
function ImgBox(array: ImageConfig[] = [], dir = "phone_light") {
  return array.map((ele: any) => (
    <div
      key={ele.url}
      className={classNames(styles.imgs, { [styles.isJ18Full]: isJ18Full })}
    >
      {smallPad ? (
        <img
          alt="img"
          className={styles.smallPad}
          src={require(`../../image/${dir}/smart/${ele.url}`)}
        />
      ) : (
        <img alt="img" src={require(`../../image/${dir}/${ele.url}`)} />
      )}
      {ele.version && <div className={styles.imgDesc}>{ele.version}</div>}
    </div>
  ));
}

export default function CommonPage() {
  const [pageContent, setPageContent] = useState({ title: "", content: [] });
  const location = useLocation();
  const isDark = getDarkMode();
  const condition = new Map([
    // pad dark模式
    [
      { isDark: true, isPad: true },
      { listObj: "padImgList", imgDIR: "pad_dark" }
    ],
    // pad light模式
    [
      { isDark: false, isPad: true },
      { listObj: "padImgList", imgDIR: "pad_light" }
    ],
    // phone dark
    [
      { isDark: true, isPad: false },
      { listObj: "phoneImgList", imgDIR: "phone_dark" }
    ],
    // phone light模式
    [
      { isDark: false, isPad: false },
      { listObj: "phoneImgList", imgDIR: "phone_light" }
    ]
  ]);

  let action = [...condition].filter(
    ([key]) => key.isDark === isDark && key.isPad === isPad
  );
  const [, { listObj, imgDIR }] = action[0];

  useEffect(() => {
    const hashUrl = location.pathname.slice(1);
    import(`../../lists/${hashUrl}.json`).then((module) => {
      setPageContent(module.default);
    });
  }, [location]);

  return (
    <div
      className={classNames({
        [styles.pad_wrap]: isPad,
        [styles.wrap]: !isPad
      })}
    >
      {isPad || isJ18 || <header>{pageContent.title}</header>}
      <div className={classNames(styles.content, { [styles.isJ18]: isJ18 })}>
        {pageContent.content.map((item: any, index: number) => (
          <div className={styles.listItem} key={index}>
            <p>
              {index + 1}.<span className={styles.text}>{item.header}</span>
            </p>
            {ImgBox(item[listObj], imgDIR)}
            {item.tip && <p className={styles.tip}>{item.tip}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
